import React from 'react';
import { Box, Typography } from '@mui/material';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';

interface RssiIndicatorProps {
  rssi: number;
}

const RssiIndicator: React.FC<RssiIndicatorProps> = ({ rssi }) => {
  let color: string;
  let text: string;
  let Icon: typeof SignalCellularAltIcon;

  if (rssi >= -65) {
    color = 'green';
    text = 'Good';
    Icon = SignalCellularAltIcon;
  } else if (rssi >= -75) {
    color = 'orange';
    text = 'Fair';
    Icon = SignalCellularAlt2BarIcon;
  } else {
    color = 'red';
    text = 'Poor';
    Icon = SignalCellularAlt1BarIcon;
  }

  return (
    <Box display="flex" alignItems="center">
      <Icon style={{ color, marginRight: 8 }} />
      <Typography color={color}>{text} ({rssi} dBm)</Typography>
    </Box>
  );
};

export default RssiIndicator;
